// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1521":"ecc43e9a3c61fc1d","7958":"c89a30e7754ee58a"}[chunkId] + ".css";
};